import { isBetterHost } from 'hostsConfig';

export const beforeAppRender = () => {
  document.querySelector('#page-title').innerHTML = isBetterHost
    ? 'BETER iFrame Demo'
    : 'GREAT_SPORTSBOOK Demo';
  document.querySelector('#favicon').href = isBetterHost
    ? '/better_favicon.png'
    : '/favicon.ico';
};
